import styled, { css } from "styled-components";
import { breakpoints } from "@tvg/design-system";
import { BetSlipContainerProps } from "./types";

export const BetSlipContainer = styled.div<BetSlipContainerProps>`
  padding-right: ${({ theme, isFloating }) =>
    isFloating ? theme.space["space-4"] : 0};
  padding-left: ${({ theme, isFloating }) =>
    isFloating ? theme.space["space-4"] : 0};
  transition: padding-left 0.2s linear;
  /* stylelint-disable media-query-no-invalid */
  @media screen and ${breakpoints.desktop.min.xl} {
    ${({ isFloating, isBetSlipExpanded }) =>
      isFloating &&
      css`
        padding-left: ${isBetSlipExpanded
          ? "90px"
          : "calc(var(--lhn-width, 292px) + 27px)"};
      `};
  }

  ${({ isError, theme, isExtendedSelections }) =>
    isError &&
    isExtendedSelections &&
    css`
      border: solid ${theme.colorTokens.component.notification.negative.border};
      border-top: none;
    `}

  @media screen and ${breakpoints.tablet.max.sm} {
    padding: 0;
  }
`;

const flexCenter = css`
  display: flex;
  align-items: center;
`;

export const BetSlipWrapper = styled.div<{
  hasRadiusTop: boolean;
  isError: boolean;
  isExtendedSelections: boolean;
  isFloating: boolean;
}>`
  height: 68px;
  ${flexCenter};
  padding: var(--fd-space-space-3) var(--fd-space-space-3)
    var(--fd-space-space-3) var(--fd-space-space-1);
  background-color: var(--fd-colors-racing-betslip-background);
  box-shadow: var(--fd-shadows-elevations-all-around-high);
  position: relative;
  z-index: 900;
  ${({ hasRadiusTop, isError, isFloating }) =>
    hasRadiusTop && !isError
      ? css`
          border-radius: ${isFloating ? "4px" : 0};
        `
      : css`
          border-radius: ${isFloating ? "0 0 4px 4px" : 0};
        `}
  ${({ isError, theme, isExtendedSelections }) =>
    isError &&
    !isExtendedSelections &&
    css`
      border: solid ${theme.colorTokens.component.notification.negative.border};
      border-top: none;
    `}

  @media screen and ${breakpoints.tablet.max.sm} {
    border-radius: 0;
  }
`;

export const LeftColumn = styled.div`
  ${flexCenter};
  flex: 1;
  min-width: 0;
  margin-right: var(--fd-space-space-3);

  @media screen and ${breakpoints.tablet.max.sm} {
    flex: inherit;
  }
`;

export const RightColumn = styled.div`
  ${flexCenter};
  flex-shrink: 1;
  justify-content: end;
  gap: var(--fd-space-space-2);

  @media screen and ${breakpoints.tablet.max.sm} {
    flex: 1;

    & > button {
      flex-grow: 1;
    }
  }
`;

export const BetSelectionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--fd-space-space-2);
`;
